import { useContext } from 'react'

import { SocketsContext } from '../contexts/sockets.context'

export const useSocket = () => {
  const socket = useContext(SocketsContext)

  if (!socket) {
    console.error('useSocket must be used within a SocketProvider.')
    throw new Error('useSocket must be used within a SocketProvider.')
  }

  return socket
}
